import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-ai-assistant',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="AI Assistant" apiPath="ai-assistant" />`
})
export class AiAssistantComponent {}
